<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Email" formControlName="email">
    <form-group-simple name="email" placeholder="Email"></form-group-simple>
  </form-group-context>

  <form-group-context label="First Name" formControlName="firstName">
    <form-group-simple name="firstName" placeholder="First Name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Second Name" formControlName="secondName">
    <form-group-simple name="secondName" placeholder="Second Name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Password" formControlName="password">
    <form-group-simple name="password" inputType="password" placeholder="Password"></form-group-simple>
  </form-group-context>

  <form-group-context label="Active" formControlName="active">
    <form-group-simple type="checkbox" name="active"></form-group-simple>
  </form-group-context>

  <form-group-context label="Admin" formControlName="admin">
    <form-group-simple type="checkbox" name="admin"></form-group-simple>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
